<script setup lang="ts">
import { AbcHeading } from "@ordbogen-npm/abc-dsk";
import { useBreakpoints } from "@vueuse/core";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { type RouteLocationRaw, RouterLink } from "vue-router";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import { Size } from "@/abc-dsk/options";
import config from "@/common/config";

import PromotionHighlight from "./PromotionHighlight.vue";

const emit = defineEmits<{
  clickCta: [];
}>();

const { t } = useI18n();
const breakpoints = useBreakpoints(config.breakpoints);

const toRoute = computed<RouteLocationRaw>(() => ({
  path: "ordbogen/german/workshop/inflection-trainer",
  query: {
    query: "Apfel",
    wordClass: "noun"
  }
}));
</script>

<template>
  <div class="inflection-scheme-tool-promotion">
    <PromotionHighlight size="sm">
      <div class="inflection-scheme-tool-promotion-highlight__inner">
        <div class="inflection-scheme-tool-promotion__text">
          <AbcHeading tag="h2" size="md">{{
            t("promotions.inflection-scheme-tool.headline")
          }}</AbcHeading>
          <p>{{ t("promotions.inflection-scheme-tool.text") }}</p>
          <RouterLink :to="toRoute">
            <TgButton
              :size="Size.Sm"
              :full-width="breakpoints.smallerOrEqual('sm').value"
              @click="emit('clickCta')"
            >
              {{ t("promotions.inflection-scheme-tool.button") }}
            </TgButton>
          </RouterLink>
        </div>
      </div>
    </PromotionHighlight>

    <div class="inflection-scheme-tool-promotion__image">
      <img
        src="@/assets/img/home/promotion/inflection-scheme-tool.png"
        srcset="@/assets/img/home/promotion/inflection-scheme-tool.png"
        loading="lazy"
        alt=""
      />
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.inflection-scheme-tool-promotion {
  display: flex;
  align-items: center;
  justify-content: center;

  &__text {
    width: 294px;
  }

  &__image {
    display: none;

    #media-breakpoint-up(lg, {
      display: block;
      margin-left: -85px;
      position: relative;
      bottom: 18px;
    });
  }

  &-highlight__inner {
    width: 393px;
    padding-left: 47px;
  }
}
</style>
